import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getGameType } from "@/api/dataAll/gameDtailss";
import { getGamedetailing, deleGamedetailing } from "@/api/dataAll/gameDtailss";
import addGamedetail from "./components/addGamedetail";
export default {
  name: "gameDetail",
  components: {
    addGamedetail: addGamedetail
  },
  data: function data() {
    return {
      total: 0,
      pagrSize: 10,
      searchData: {
        page: 1,
        game: ''
      },
      showing: false,
      tableData: [],
      addWayConfig: false,
      gameData: []
    };
  },
  created: function created() {
    var _this = this;

    getGameType().then(function (res) {
      _this.gameData = res.data;
    });
  },
  methods: {
    gamechange: function gamechange(val) {
      this.searchMark.game = val;
    },
    searchClick: function searchClick() {
      var _this2 = this;

      getGamedetailing(this.searchMark).then(function (res) {
        _this2.tableData = res.data.data || [];
        _this2.total = res.data.total - 0 || 0;
      });
    },
    handleSource: function handleSource(id, num) {
      var _this3 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this3.showing = true;

        _this3.$refs.addWayConfig.init(id, num);
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchMark.page = val;
      this.searchData.page = val;
      this.searchClick();
    },
    handleDelete: function handleDelete(id) {
      var _this4 = this;

      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deleGamedetailing({
                  id: id
                }).then(function (res) {
                  _this4.searchClick();
                });

                _this4.$message({
                  type: "success",
                  message: "删除成功!"
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    }
  }
};